/* esdivnt-disable react/require-default-props */
import React from 'react';
import cx from 'classnames';

const Crumbtrail = ({ active, projectSmartEnabledDraft = false }) => {
  const commonCrumbClass =
    'relative rounded-full w-10 h-10 flex items-center justify-center text-base';
  const activeClass = 'bg-[#434B58] text-white';
  const inactiveClass = 'bg-[#F4F5F7]';

  return (
    <div
      className={cx('flex justify-between  items-center mx-auto mb-16', {
        'w-[75%]': projectSmartEnabledDraft,
        'w-[60%]': !projectSmartEnabledDraft,
      })}
    >
      <div
        id="crumb-1"
        title="New Project Name"
        className={cx(`${commonCrumbClass} ${activeClass}`, {
          // [inactiveClass]: active <= 0,
          // [activeClass]: active > 0,
        })}
      >
        <span>1</span>
        <span className={cx('absolute top-12 text-[12px] text-black', {})}>Name</span>
      </div>
      <div
        id="crumb-2"
        title="Enable Smart"
        className={cx(commonCrumbClass, {
          [inactiveClass]: active < 1,
          [activeClass]: active >= 1,
        })}
      >
        <div
          className={cx('relative w-10 h-1 right-10', {
            [inactiveClass]: active < 1,
            [activeClass]: active >= 1,
          })}
        />
        <span className="absolute">2</span>
        <span
          className={cx('absolute top-12 text-[12px]', {
            'text-[#434C5899]/60': active < 1,
            'text-black': active >= 1,
          })}
        >
          Colour
        </span>
      </div>

      <div
        id="crumb-3"
        title="Categories"
        className={cx(commonCrumbClass, {
          [inactiveClass]: active < 2,
          [activeClass]: active >= 2,
        })}
      >
        <div
          className={cx('relative w-10 h-1 right-10', {
            [inactiveClass]: active < 2,
            [activeClass]: active >= 2,
          })}
        />
        <span className="absolute">3</span>
        <span
          className={cx('absolute top-12 text-[12px]', {
            'text-[#434C5899]/60': active < 2,
            'text-black': active >= 2,
          })}
        >
          Capabilities
        </span>
      </div>

      {projectSmartEnabledDraft && (
        <div
          id="crumb-5"
          title="Select Project Circles"
          className={cx(commonCrumbClass, {
            [inactiveClass]: active < 3,
            [activeClass]: active >= 3,
          })}
        >
          <div
            className={cx('relative w-10 h-1 right-10', {
              [inactiveClass]: active < 3,
              [activeClass]: active >= 3,
            })}
          />
          <span className="absolute">4</span>
          <span
            className={cx('absolute top-12 text-[12px]', {
              'text-[#434C5899]/60': active < 3,
              'text-black': active >= 3,
            })}
          >
            Categories
          </span>
        </div>
      )}
      <div
        id="crumb-6"
        title="Select Participants"
        className={cx(commonCrumbClass, {
          [inactiveClass]: projectSmartEnabledDraft ? active < 4 : active < 3,
          [activeClass]: projectSmartEnabledDraft ? active >= 4 : active >= 3,
        })}
      >
        <div
          className={cx('relative w-10 h-1 right-10', {
            [inactiveClass]: projectSmartEnabledDraft ? active < 4 : active < 3,
            [activeClass]: projectSmartEnabledDraft ? active >= 4 : active >= 3,
          })}
        />
        <span className="absolute">{projectSmartEnabledDraft ? '5' : '4'}</span>
        <span
          className={cx('absolute top-12 text-[12px]', {
            'text-[#434C5899]/60': projectSmartEnabledDraft ? active < 4 : active < 3,
            'text-black': projectSmartEnabledDraft ? active >= 4 : active >= 3,
          })}
        >
          Members
        </span>
      </div>
    </div>
  );
};

export default Crumbtrail;
